export const queryPage = '/icps/system/sign/basics/jjg/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/basics/jjg/deletes'
export const saveOrUpdate = '/icps/system/sign/basics/jjg/saveOrUpdate'
export const Download = '/icps/system/sign/basics/jjg/exportList'
import request from '@/utils/request'
export function jjgqueryPage(data) {
  return request({
    url: '/icps/system/sign/basics/jjgCalibration/queryPage',
    method: 'post',
    data
  })
}

export function getLimit(data) {
  return request({
    url: '/icps/system/sign/basics/jjgLimit/getDetails',
    method: 'post',
    data
  })
}
/**
 * 保存设置上下值
*/
export function setLimit(data) {
  return request({
    url: '/icps/system/sign/basics/jjgLimit/save',
    method: 'post',
    data
  })
}
/**
 * @method 获取回弹系数
 * @param {Object} data 传参数
 * @exports 
*/
export function getJJGconefficient(data) {
  return request({
    url: '/icps/system/sign/basics/JJGconefficient/getAllList',
    method: 'post',
    data
  })
}
/**
 * @method 保存回弹系数
 * @exports
*/
export function setJJGconefficient(data) {
  return request({
    url: '/icps/system/sign/basics/JJGconefficient/save',
    method: 'post',
    data
  })
}